module.exports = "pegasus/assets/blocks/column-13-theme3.png";